import { useEffect, useState } from 'react';
/** Subscribe to prefers-reduced-motion changes reactively. */
export function usePrefersReducedMotion() {
    const [reduced, setReduced] = useState(() => typeof window !== 'undefined'
        ? window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
        : false);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const mql = window.matchMedia?.('(prefers-reduced-motion: reduce)');
        if (!mql)
            return;
        const handler = (e) => setReduced(e.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, []);
    return reduced;
}
//# sourceMappingURL=usePrefersReducedMotion.js.map